module.exports = __webpack_public_path__ + "media/images/game/pages/logo_nadace_drfg-74f811eb31a541d7f3d6854b6a4b2620.jpg";